import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { CalendarTransparency } from 'types/event.types';

export interface UpdateCalendarSettingsInputType {
  eventId: number;
  calendarNotifications: boolean;
  sendCalendarInvites: boolean;
  transparency: CalendarTransparency;
}

export interface UpdateCalendarSettingsResult {
  updateCalendarSettings: {
    event: {
      calendarNotifications: boolean;
      sendCalendarInvites: boolean;
      transparency: CalendarTransparency;
    };
    ok: boolean;
  };
}

const UpdateCalendarSettingsMutation = gql`
  mutation updateCalendarSettings($input: UpdateCalendarSettingsInputType!) {
    updateCalendarSettings(input: $input) {
      ok
      event {
        calendarNotifications
        sendCalendarInvites
        transparency
      }
    }
  }
`;

export const updateCalendarSettings = (
  input: UpdateCalendarSettingsInputType
): Promise<UpdateCalendarSettingsResult> => {
  return gqlClient.request<UpdateCalendarSettingsResult>(UpdateCalendarSettingsMutation, {
    input
  });
};
